import React, {Fragment, useEffect, useRef, useState} from "react";
import {MenuItem, PopoverInteractionKind} from "@blueprintjs/core";
import {MultiSelect} from "@blueprintjs/select";

import arrowDown from "../../assets/images/icons/arrow_circle_bottom.svg";
import "./MultiSelect.css"
import MenuCheckbox from "../ProductMenu/MenuCheckbox";

function SimpleMultiSelect(props) {

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [query, setQuery] = useState('');
    const selectRef = useRef(null);
    const wrapperRef = useRef(null);
    const skipNextFocusRef = useRef(false);

    let showItemImage = true;
    if(props.showItemImage != null){
        showItemImage = props.showItemImage;
    }

    const closeDropdown = () => {
        skipNextFocusRef.current = true;
        setDropdownOpen(false);
        setQuery('');
        setTimeout(() => { skipNextFocusRef.current = false; }, 200);
    };

    // Zamknij dropdown po kliknięciu poza komponentem lub poza portalem Blueprint
    useEffect(() => {
        if (!dropdownOpen) return;

        const handleOutsideClick = (e) => {
            const insideWrapper = wrapperRef.current && wrapperRef.current.contains(e.target);
            const insidePortal = !!e.target.closest('.bp3-portal');
            if (!insideWrapper && !insidePortal) {
                closeDropdown();
            }
        };

        document.addEventListener('mousedown', handleOutsideClick, true);
        return () => document.removeEventListener('mousedown', handleOutsideClick, true);
    }, [dropdownOpen]);

    const itemRenderer = (item, {modifiers, handleClick, index}) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }

        let isSelected = props.selectedItems.findIndex(selectedItem => selectedItem.name === item.name) > -1;

        let selectAllCheckbox = null;
        if (index === 0 ) {
            let isAllSelected = props.selectedItems.length === props.items.length;

            selectAllCheckbox = (
                <MenuCheckbox
                    key="all"
                    name="all"
                    checked={isAllSelected}
                    selected={props.allItemsSelected}>
                    Zaznacz wszystkie
                </MenuCheckbox>
            );

        }

        return (
            <Fragment key={item.name}>
                {selectAllCheckbox}
                <MenuCheckbox
                    name={item.name}
                    checked={isSelected}
                    image={showItemImage ? (<img src={item.image} alt={item.name}/>) : null}
                    selected={handleClick}>
                    {item.name}
                </MenuCheckbox>
            </Fragment>
        );
    };

    const filterItemHandler = (query, item, _index, exactMatch) => {
        const normalizedTitle = item.name.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedTitle === normalizedQuery;
        } else {
            return `${normalizedTitle}`.indexOf(normalizedQuery) >= 0;
        }
    };

    const COLLAPSE_AT = 2; // 3+ wybranych → skrócony tag
    const collapsed = props.selectedItems.length > COLLAPSE_AT;

    const tagRendered = (item) => {
        if (!collapsed) return item.name;
        // Tylko pierwszy element dostaje label z licznikiem; reszta → null (Blueprint pomija)
        return item === props.selectedItems[0]
            ? `Wybrano ${props.selectedItems.length}`
            : null;
    };

    const handleRemove = (value) => {
        if (collapsed) {
            // Kliknięcie X na „Wybrano N" → odznacz wszystkie
            props.allItemsSelected && props.allItemsSelected({ target: { checked: false } });
        } else {
            props.itemDeselected(value);
        }
    };

    return (
        <div ref={wrapperRef} style={{width: '100%'}}>
            <MultiSelect
                ref={selectRef}
                className="multiSelect"
                fill={true}
                itemRenderer={props.itemRenderer == null ? itemRenderer : props.itemRenderer}
                itemPredicate={props.itemPredicate == null ? filterItemHandler : props.itemPredicate}
                onItemSelect={props.itemSelected}
                query={query}
                onQueryChange={(q) => { setQuery(q); setDropdownOpen(true); }}
                items={props.items}
                tagRenderer={tagRendered}
                noResults={<MenuItem disabled={true} text="Najpierw wybierz markę"/>}
                popoverProps={{
                    isOpen: dropdownOpen,
                    minimal: true,
                    fill: true,
                    usePortal: true,
                    interactionKind: PopoverInteractionKind.CLICK,
                    onOpening: () => setDropdownOpen(true),
                    onClosing: () => setDropdownOpen(false)
                }}
                placeholder={props.placeholder}
                tagInputProps={{
                    className: "like-btn",
                    onRemove: handleRemove,
                    rightElement: (<img className={"multiSelectDownArrow " + (dropdownOpen ? "open" : "")} src={arrowDown}
                                        onClick={() => dropdownOpen ? closeDropdown() : setDropdownOpen(true)} alt="open/close"/>),
                    tagProps: {minimal: true},
                    inputProps: {
                        onFocus: () => {
                            if (skipNextFocusRef.current) return;
                            setDropdownOpen(true);
                        }
                    }
                }}
                selectedItems={props.selectedItems}
                activeItem={null}
            />
        </div>
    );
}

export default SimpleMultiSelect;
